import styled, { css } from 'styled-components';
import { SaveRibbonButton } from 'src/components';

export const Container = styled.div`
  position: relative;
`;

export const Card = styled.button(
  ({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    aspect-ratio: 3 / 4;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: none;
    border-radius: ${theme.bo.small};
    background-color: ${theme.co.neutral30};
    text-align: left;
    cursor: pointer;

    &:focus-visible {
      outline: ${theme.bo.mediumWidth} solid ${theme.co.primary20};
      outline-offset: ${theme.bo.mediumWidth};
    }
  `,
);

export const Thumbnail = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`;

export const Caption = styled.span(
  ({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    padding: ${theme.sz.s8} ${theme.sz.s2} ${theme.sz.s2};
    background: linear-gradient(to bottom, transparent, ${theme.co.neutral0});
    color: ${theme.co.neutral99};
  `,
);

export const Learnable = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xxs};
    overflow-wrap: anywhere;
  `,
);

export const Translation = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    overflow-wrap: anywhere;
  `,
);

export const SaveButton = styled(SaveRibbonButton)(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.sz.s2};
    right: ${theme.sz.s2};
  `,
);
